import React, { Component } from "react";
import dayjs from "dayjs";
import Cookies from "universal-cookie";
import axios from "axios";
import {
  Table,
  Tag,
  Dropdown,
  Button,
  Space,
  Badge,
  Tooltip,
  Input,
  Modal,
  DatePicker,
  message,
  Popover,
} from "antd";
import {
  MoreOutlined,
  EyeOutlined,
  TeamOutlined,
  LoadingOutlined,
  SettingOutlined,
  RedoOutlined,
  EuroCircleOutlined,
} from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { getMondayAndSaturday } from "../HomeVisits/utils/getMondayAndSaturday";
import { strToSlug } from "./util/strToSlug";
dayjs.extend(customParseFormat);

class AppointmentsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      idToReopen: null,
      loading: false,
      appointments: [],
      appointments_copy: [],
      visitTypes: [],
      technicians: [],
      statuses: [],
      locality: [],
      filteredInfo: {},
      sortedInfo: {},
      configModal: false,
    };
    this.clearAll = this.clearAll.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.changeDate = this.changeDate.bind(this);
    this.getLocality = this.getLocality.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getVisitTypes = this.getVisitTypes.bind(this);
    this.getCurrentWeek = this.getCurrentWeek.bind(this);
    this.getTechnicians = this.getTechnicians.bind(this);
    this.getAppointments = this.getAppointments.bind(this);
    this.reopenAppointment = this.reopenAppointment.bind(this);
    this.getAllTechnicians = this.getAllTechnicians.bind(this);
  }
  async componentDidMount() {
    this.setState({ loading: true });
    const cookies = new Cookies();
    const filters = cookies.get("filtered_info");
    const sorter = cookies.get("sort_info");
    const start_date = cookies.get("start_date");
    const end_date = cookies.get("end_date");
    const { monday, saturday } = getMondayAndSaturday(Date.now());
    const formatted = await this.getAppointments(
      start_date ? start_date : monday,
      end_date ? end_date : saturday
    );
    await this.getVisitTypes();
    this.setState(
      {
        appointments: formatted,
        appointments_copy: formatted,
        startDate: start_date
          ? dayjs(start_date, "YYYY-MM-DD")
          : dayjs(monday, "YYYY-MM-DD"),
        endDate: end_date
          ? dayjs(end_date, "YYYY-MM-DD")
          : dayjs(saturday, "YYYY-MM-DD"),
        filteredInfo: filters,
        sortedInfo: sorter,
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }
  async getAppointments(startDate, endDate) {
    let startDateMillis = new Date(startDate).getTime();
    let endDateMillis = new Date(endDate).getTime();
    return await this.props.userData
      .searchHomeVisits("", startDateMillis, endDateMillis)
      .then((res) => {
        if (typeof res !== "undefined") {
          // Llamamos a getLocality para extaer las localidades disponibles en la lista de citas obtenida
          this.getLocality(res.data);
          this.getStatus(res.data);
          // Llamamos a getTechnicians para extaer los técnicos
          this.getTechnicians(res.data);
          const regex = /(<([^>]+)>)/gi;
          const formatted = res.data.map((element) => {
            // Vamos primero a juntar tanto técnicos asignados como trabajando
            let rawTechnicians = [
              ...element.assigned_technician,
              ...element.working_technician,
            ];
            let technicians = [];
            // Recorremos el merge de técnicos
            if (rawTechnicians.length > 0) {
              rawTechnicians.map((rawTech) => {
                // Añadimos cada técnico al array usando como key el id del técnico (evitando duplicados)
                technicians[rawTech.id] = rawTech;
              });
            }
            // Si hay técnicos, quitamos las keys y nos quedamos con los values
            if (technicians.length > 0)
              technicians = Object.values(technicians);
            let arrayDate = element.visit_date_day
              .replace(regex, "")
              .split("/");
            if (arrayDate[0].length === 1) arrayDate[0] = "0" + arrayDate[0];
            arrayDate = arrayDate.join("/");
            return {
              key: element.id,
              id: element.id,
              title: element.title,
              visit_type: {
                code: element.visit_type.tid,
                name: element.visit_type_name,
              },
              visit_status: {
                code: element.visit_status.tid,
                name: element.visit_status_name,
              },
              finish_reason:
                typeof element.finish_reason_name === "string"
                  ? {
                      text: element.finish_reason_name,
                      value: element.finish_reason.tid,
                    }
                  : null,
              visit_locality: element.visit_locality,
              visit_address: `${element.visit_address}, ${element.visit_locality}`,
              visit_date: `${arrayDate} ${element.visit_date_hour.replace(regex, "")}`,
              technician: technicians,
              billing_status: element.billing_status.tid,
              child_id: Array.isArray(element.child_id)
                ? null
                : element.child_id,
              parent_id: Array.isArray(element.parent_id)
                ? null
                : element.parent_id,
            };
          });
          return formatted;
        }
      });
  }
  async getLocality(appointments) {
    const res = appointments;
    if (typeof res !== "undefined") {
      const allLocality = res.map((element) => ({
        text: element.visit_locality,
        value: strToSlug(element.visit_locality),
      }));
      const uniqueValuesSet = new Set();
      const uniqueAllLocality = allLocality.filter((item) => {
        if (!uniqueValuesSet.has(item.value)) {
          uniqueValuesSet.add(item.value);
          return true;
        }
        return false;
      });
      this.setState({ locality: uniqueAllLocality });
    }
  }
  async getVisitTypes() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let url = "https://oficina.nadunet.es/api/rest/get-home-visit-types-list";
    const res = await axios.get(url, queryHeaders, { withCredentials: true });
    const formatted = res.data.map((type) => ({
      text: type.label,
      value: type.value,
    }));
    this.setState({ visitTypes: formatted });
  }
  async getTechnicians(appointments) {
    let technicians = [];
    const formatted = appointments.map((element) => {
      // Vamos primero a juntar tanto técnicos asignados como trabajando
      let rawTechnicians = [
        ...element.assigned_technician,
        ...element.working_technician,
      ];
      // Recorremos el merge de técnicos
      if (rawTechnicians.length > 0) {
        rawTechnicians.map((rawTech) => {
          // Añadimos cada técnico al array usando como key el id del técnico (evitando duplicados)
          technicians[rawTech.id] = {
            text: rawTech.username,
            value: rawTech.id,
          };
        });
      }
    });
    // Si hay técnicos, quitamos las keys y nos quedamos con los values
    if (technicians.length > 0) technicians = Object.values(technicians);
    this.setState({ technicians: technicians });
  }
  async getAllTechnicians() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let url = "https://oficina.nadunet.es/api/rest/get-technicians-list";
    const res = await axios.get(url, queryHeaders, { withCredentials: true });
    const formatted = res.data.map((type) => ({
      text: type.label,
      value: type.value,
    }));
    this.setState({ technicians: formatted });
  }
  async getStatus(appointments) {
    let allStatus = {};
    appointments.forEach((element) => {
      allStatus[element.visit_status.tid] = {
        text: element.visit_status_name,
        value: element.visit_status.tid,
      };

      if (element.finish_reason.tid) {
        if (element.finish_reason.tid !== "257") {
          allStatus[element.finish_reason.tid] = {
            text: element.finish_reason_name,
            value: element.finish_reason.tid,
          };
        }
      }
    });
    if (Object.values(allStatus).length > 0)
      allStatus = Object.values(allStatus);
    this.setState({ statuses: allStatus });
  }
  async reopenAppointment(id) {
    try {
      let queryHeaders = {
        headers: {
          "X-CSRF-Token": localStorage.getItem("token"),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      let url =
        "https://oficina.nadunet.es/api/rest/nadunet_office_resources/reopen_home_visit";
      let request = { id: Number(id) };
      const res = await axios.post(url, request, queryHeaders, {
        withCredentials: true,
      });
      if (res.data.ok) {
        const appointments = [...this.state.appointments];
        const newAppointments = appointments.map((element, idx) => {
          if (element.id === id) {
            const { finish_reason, ...restElement } = element;
            return {
              ...restElement,
              visit_status: res.data.visit_status,
              finish_reason:
                res.data.visit_status.code !== "249" ? null : finish_reason,
            };
          }
          return element;
        });
        this.setState({
          appointments: newAppointments,
          appointments_copy: newAppointments,
        });
        message.success("La cita ha sido reabierta correctamente");
      } else {
        message.error(res.data.error);
      }
    } catch (error) {
      message.error("Hubo un error al reabrir la cita");
    }
  }
  onSearch(input) {
    const formattedInput = input.toLowerCase();
    const newRows = [...this.state.appointments].filter((appointment) => {
      for (let prop in appointment) {
        if (
          typeof appointment[prop] === "string" &&
          appointment[prop].toLowerCase().includes(formattedInput)
        ) {
          return true;
        } else if (
          appointment[prop] !== null &&
          typeof appointment[prop] === "object" &&
          appointment[prop].name &&
          appointment[prop].name.toLowerCase().includes(formattedInput)
        ) {
          return true;
        }
      }
      return false;
    });
    if (newRows.length <= 0 || input.length === 0) {
      this.setState({ appointments: this.state.appointments_copy });
    } else {
      this.setState({ appointments: newRows });
    }
  }
  async changeDate(dateRage) {
    const cookies = new Cookies();
    this.setState({ loading: true });
    const [startDate, endDate] = dateRage;
    const startDay = dayjs(startDate).format("YYYY-MM-DD");
    const endDay = dayjs(endDate).format("YYYY-MM-DD");
    cookies.set("start_date", startDay, {
      path: "/",
    });
    cookies.set("end_date", endDay, {
      path: "/",
    });
    const formatted = await this.getAppointments(startDay, endDay);
    this.setState(
      {
        appointments: formatted,
        appointments_copy: formatted,
        startDate: startDate,
        endDate: endDate,
      },
      () => this.setState({ loading: false })
    );
  }
  handleChange(pagination, filters, sorter) {
    const cookies = new Cookies();
    cookies.set("filtered_info", filters, {
      path: "/",
    });
    cookies.set("sort_info", sorter, {
      path: "/",
    });
    this.setState({ filteredInfo: filters, sortedInfo: sorter });
  }
  async clearAll() {
    this.setState({ loading: true });
    const cookies = new Cookies();
    cookies.remove("filtered_info", {
      path: "/",
    });
    cookies.remove("sort_info", {
      path: "/",
    });
    this.setState(
      {
        filteredInfo: {},
        sortedInfo: {},
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }
  async getCurrentWeek() {
    this.setState({ loading: true });
    const cookies = new Cookies();
    const { monday, saturday } = getMondayAndSaturday(Date.now());
    const formatted = await this.getAppointments(monday, saturday);
    cookies.set("start_date", monday, {
      path: "/",
    });
    cookies.set("end_date", saturday, {
      path: "/",
    });
    await this.getVisitTypes();
    this.setState(
      {
        appointments: formatted,
        appointments_copy: formatted,
        startDate: dayjs(monday, "YYYY-MM-DD"),
        endDate: dayjs(saturday, "YYYY-MM-DD"),
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }

  render() {
    const billingCondition = {
      title: "Facturación",
      dataIndex: "billing_status",
      key: "billing_status",
      align: "center",
      filters: [
        { text: "Pendiente", value: 374 },
        { text: "En proceso", value: 377 },
        { text: "Revisado", value: 375 },
      ],
      filteredValue:
        (this.state.filteredInfo && this.state.filteredInfo.billing_status) ||
        null,
      onFilter: (value, record) => Number(record.billing_status) === value,
      render: (billing_status) => (
        <EuroCircleOutlined
          style={{
            fontSize: 18,
            color:
              Number(billing_status) === 374
                ? "red"
                : Number(billing_status) === 377
                  ? "yellow"
                  : "green",
          }}
        />
      ),
    };
    const columns = [
      this.props.isBillingDepartment() && billingCondition,
      {
        title: "Fecha",
        dataIndex: "visit_date",
        key: "visit_date",
        showSorterTooltip: false,
        sortOrder:
          this.state.sortedInfo &&
          this.state.sortedInfo.columnKey === "visit_date"
            ? this.state.sortedInfo.order
            : null,
        sortDirections: ["descend"],
        sorter: (a, b) => {
          return (
            dayjs(a.visit_date, "DD/MM/YYYY HH:mm").unix() -
            dayjs(b.visit_date, "DD/MM/YYYY HH:mm").unix()
          );
        },
      },
      {
        title: "Título",
        dataIndex: "title",
        key: "title",
        ellipsis: true,
        render: (title) => (
          <Tooltip placement="bottomLeft" title={title} arrow={false}>
            {title}
          </Tooltip>
        ),
      },
      {
        title: "Tipo de cita",
        dataIndex: "visit_type",
        key: "visit_type",
        align: "center",
        filters: this.state.visitTypes,
        filteredValue:
          (this.state.filteredInfo && this.state.filteredInfo.visit_type) ||
          null,
        onFilter: (value, record) => {
          return record.visit_type.code === value;
        },
        render: (visit_type) => (
          <Tag
            color={
              visit_type.code === "243"
                ? "purple"
                : visit_type.code === "244"
                  ? "red"
                  : visit_type.code === "245"
                    ? "cyan"
                    : visit_type.code === "246"
                      ? "lime"
                      : visit_type.code === "256"
                        ? "geekblue"
                        : "gold"
            }
          >
            {visit_type.name}
          </Tag>
        ),
      },
      {
        title: "Localidad",
        dataIndex: "visit_locality",
        key: "visit_locality",
        align: "center",
        filters: this.state.locality,
        filteredValue:
          (this.state.filteredInfo && this.state.filteredInfo.visit_locality) ||
          null,
        onFilter: (value, record) => strToSlug(record.visit_locality) === value,
      },
      {
        title: "Estado",
        dataIndex: "visit_status",
        key: "visit_status",
        filters: this.state.statuses,
        filteredValue:
          (this.state.filteredInfo && this.state.filteredInfo.visit_status) ||
          null,
        onFilter: (value, record) =>
          record.finish_reason
            ? Number(value) > 250 && Number(record.finish_reason.value) !== 257
              ? Number(record.finish_reason.value) === Number(value)
              : Number(record.visit_status.code) === Number(value) &&
                Number(record.finish_reason.value) === 257
            : Number(record.visit_status.code) === Number(value),

        render: (visit_status, fullAppointment) => {
          const { finish_reason } = fullAppointment;
          const parent_id = fullAppointment.parent_id !== null;
          const child_id = fullAppointment.child_id !== null;
          return (
            <Space>
              <Space
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0,
                }}
              >
                <Tooltip
                  placement="bottom"
                  title={
                    parent_id ? (
                      <div
                        style={{
                          margin: 0,
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Button
                          type="link"
                          style={{
                            color: "white",
                          }}
                          onClick={() =>
                            window.open(
                              `/citas/${fullAppointment.parent_id}`,
                              "_blank"
                            )
                          }
                        >
                          Ir a cita anterior
                        </Button>
                      </div>
                    ) : (
                      ""
                    )
                  }
                >
                  <Badge dot={parent_id} color={parent_id ? "green" : ""} />
                </Tooltip>
                <Tooltip
                  placement="bottom"
                  title={
                    child_id ? (
                      <div
                        style={{
                          margin: 0,
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <Button
                          type="link"
                          style={{
                            color: "white",
                          }}
                          onClick={() =>
                            window.open(
                              `/citas/${fullAppointment.child_id}`,
                              "_blank"
                            )
                          }
                        >
                          Ir a cita reagendada
                        </Button>
                      </div>
                    ) : (
                      ""
                    )
                  }
                >
                  <Badge dot={child_id} color={child_id ? "volcano" : ""} />
                </Tooltip>
              </Space>
              <Tag
                color={
                  visit_status.code === "250"
                    ? "error"
                    : visit_status.code === "247"
                      ? "warning"
                      : visit_status.code === "248"
                        ? "processing"
                        : visit_status.code === "249" &&
                            finish_reason.value === "257"
                          ? "success"
                          : "error"
                }
              >
                {visit_status.code === "249" &&
                fullAppointment.finish_reason &&
                fullAppointment.finish_reason.value !== "257"
                  ? fullAppointment.finish_reason.text
                  : visit_status.name}
              </Tag>
            </Space>
          );
        },
      },
      {
        title: "Técnicos",
        dataIndex: "technician",
        key: "technician",
        filters: this.state.technicians,
        filteredValue:
          (this.state.filteredInfo && this.state.filteredInfo.technician) ||
          null,
        onFilter: (value, record) => {
          let result = false;
          // Recorremos los técnicos de la cita y comprobamos si alguno coincide con el filtro
          for (let i = 0; i < record.technician.length; i++) {
            let _technician = record.technician[i];
            if (parseInt(_technician.id) === parseInt(value)) return true;
          }
          return result;
        },
        render: (technician) =>
          technician.length === 0 ? (
            <TeamOutlined style={{ fontSize: 20, color: "red" }} />
          ) : (
            <Tooltip
              placement="bottom"
              title={
                <div
                  style={{
                    margin: 0,
                    padding: "0px 10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  {technician.map((tech) => (
                    <p key={tech.id} style={{ margin: 0 }}>
                      {tech.username}
                    </p>
                  ))}
                </div>
              }
            >
              <TeamOutlined style={{ fontSize: 20 }} />
            </Tooltip>
          ),
        align: "center",
      },
      {
        title: "",
        dataIndex: "action",
        key: "action",
        render: (_, options) => (
          <Dropdown
            menu={{
              items: [
                {
                  label: "Ver",
                  key: "view-appointment",
                  icon: <EyeOutlined />,
                  onClick: () => window.open(`/citas/${options.id}`, "_blank"),
                },
                {
                  label: "Reabrir",
                  key: "reopen-appointment",
                  icon: <RedoOutlined />,
                  disabled: options.visit_status.code !== "249",
                  onClick: () =>
                    this.setState({
                      isModalOpen: true,
                      idToReopen: options.id,
                    }),
                },
              ],
            }}
            placement="bottom"
          >
            <Button>
              <Space>
                Acciones
                <div className="acciones-contrato">
                  <MoreOutlined />
                </div>
              </Space>
            </Button>
          </Dropdown>
        ),
      },
    ];
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Lista Citas</h5>
                  {!this.state.loading && (
                    <Space>
                      <Popover
                        title="Configuración"
                        arrow={false}
                        trigger="click"
                        placement="bottomRight"
                        open={this.state.configModal}
                        onOpenChange={() =>
                          this.setState({ configModal: true })
                        }
                        content={
                          <Space
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Input.Search
                              placeholder="Introducir texto..."
                              enterButton="Buscar"
                              allowClear
                              onSearch={() => {
                                this.onSearch();
                                this.setState({ configModal: false });
                              }}
                              style={{ width: "100%" }}
                            />
                            <DatePicker.RangePicker
                              defaultValue={[
                                this.state.startDate,
                                this.state.endDate,
                              ]}
                              format={"DD/MM/YYYY"}
                              onChange={this.changeDate}
                              allowClear={false}
                              style={{ width: "100%" }}
                              renderExtraFooter={() => (
                                <Button
                                  type="link"
                                  onClick={() => {
                                    this.getCurrentWeek();
                                    this.setState({ configModal: false });
                                  }}
                                >
                                  Seleccionar semana actual
                                </Button>
                              )}
                            />
                            <Button
                              block
                              // style={{ width: "100%" }}
                              onClick={() => {
                                this.clearAll();
                                this.setState({ configModal: false });
                              }}
                            >
                              Limpiar filtros
                            </Button>
                            <Button
                              type="link"
                              style={{ marginTop: "16px" }}
                              onClick={() =>
                                this.setState({ configModal: false })
                              }
                            >
                              Cancelar
                            </Button>
                          </Space>
                        }
                      >
                        <Button shape="circle" icon={<SettingOutlined />} />
                      </Popover>
                    </Space>
                  )}
                </CardHeader>
                <CardBody
                  style={{
                    minHeight: "70vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {!this.state.loading ? (
                    <Table
                      scroll={{ x: 1300 }}
                      style={{ width: "100%", minHeight: "70vh" }}
                      columns={columns}
                      dataSource={this.state.appointments}
                      onChange={this.handleChange}
                      rowClassName={(record, index) =>
                        record.child_id &&
                        record.visit_status.code === "249" &&
                        record.finish_reason &&
                        record.finish_reason.value !== "257"
                          ? "antd-custom-warning-row"
                          : record.visit_status.code === "249" &&
                              record.finish_reason &&
                              record.finish_reason.value !== "257"
                            ? "antd-custom-row"
                            : "antd-default-row"
                      }
                    />
                  ) : (
                    <LoadingOutlined style={{ fontSize: "28px" }} />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal
          title="¿Deseas reabrir la cita?"
          open={this.state.isModalOpen}
          onOk={async () => {
            await this.reopenAppointment(this.state.idToReopen);
            this.setState({ isModalOpen: false, idToReopen: null });
          }}
          onCancel={() =>
            this.setState({ isModalOpen: false, idToReopen: null })
          }
        ></Modal>
      </div>
    );
  }
}

export default AppointmentsTable;



// WEBPACK FOOTER //
// ./src/views/Calendar/AppointmentsTable.jsx